// import { MaterialReactTable } from "material-react-table";

// export default function PavilionTable({ data, loading, onEdit, onDelete }) {
//   const columns = [
//     {
//       accessorKey: "pavilion_name",
//       header: "Pavilion Name",
//     },
//     {
//       header: "Actions",
//       Cell: ({ row }) => (
//         <div className="flex gap-2">
//           <button
//             onClick={() => onEdit(row.original)}
//             className="rounded bg-yellow-100 px-3 py-1 text-xs"
//           >
//             Edit
//           </button>
//           <button
//             onClick={() => {
//               if (
//                 window.confirm(
//                   `Delete Pavilion "${row.original.pavilion_name}"?`
//                 )
//               ) {
//                 onDelete(row.original);
//               }
//             }}
//             className="rounded bg-red-100 px-3 py-1 text-xs"
//           >
//             Delete
//           </button>
//         </div>
//       ),
//     },
//   ];

//   return (
//     <MaterialReactTable
//       columns={columns}
//       data={data}
//       state={{ isLoading: loading }}
//       enableExpanding
//       getSubRows={(row) => row.children}
//       enableColumnOrdering={false}
//       enableSorting={false}
//       enableColumnFilters={false}
//       muiTableBodyRowProps={{ hover: true }}
//       enableGlobalFilter={false}
//     />
//   );
// }
import { useState, useEffect, useRef } from "react";
import ConfirmModal from "components/common/ConfirmModal";
import {
  MdMoreVert,
  MdEdit,
  MdDelete,
  MdChevronRight,
  MdExpandMore,
} from "react-icons/md";

function TreeRow({
  item,
  level = 0,
  onEdit,
  onAskDelete,
  openDropdownId,
  setOpenDropdownId,
  openUpward,
  setOpenUpward,
  dropdownRef,
}) {
  const [expanded, setExpanded] = useState(false);
  const hasChildren = Array.isArray(item.children) && item.children.length > 0;
  const isMenuOpen = openDropdownId === item._id;

  const handleToggleMenu = (e) => {
    e.stopPropagation();
    if (isMenuOpen) {
      setOpenDropdownId(null);
    } else {
      const buttonRect = e.currentTarget.getBoundingClientRect();
      const spaceBelow = window.innerHeight - buttonRect.bottom;

      if (spaceBelow < 150) {
        setOpenUpward(true);
      } else {
        setOpenUpward(false);
      }

      setOpenDropdownId(item._id);
    }
  };

  return (
    <>
      <tr className="custom-table-row">
        {/* Pavilion Name (Indented with Expand Icon for Sub-Pavilions) */}
        <td className="custom-table-cell">
          <div
            className="flex items-center gap-1"
            style={{ paddingLeft: `${level * 24}px` }}
          >
            {hasChildren ? (
              <button
                type="button"
                onClick={() => setExpanded(!expanded)}
                className="p-1 text-gray-500 hover:text-gray-800"
              >
                {expanded ? (
                  <MdExpandMore className="text-lg" />
                ) : (
                  <MdChevronRight className="text-lg" />
                )}
              </button>
            ) : (
              <span className="inline-block w-6" />
            )}

            <span className="font-medium text-gray-800">
              {item.pavilion_name || "N/A"}
            </span>

            {hasChildren && (
              <span className="ml-2 rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-semibold text-gray-500">
                {item.children.length}
              </span>
            )}
          </div>
        </td>

        {/* Action Dropdown Menu Cell */}
        <td className="custom-table-cell relative text-center">
          <button onClick={handleToggleMenu} className="action-menu-btn">
            <MdMoreVert className="text-lg" />
          </button>

          {isMenuOpen && (
            <div
              ref={dropdownRef}
              className={`action-dropdown-menu ${
                openUpward ? "menu-bottom" : "menu-top"
              }`}
            >
              <button
                onClick={() => {
                  onEdit(item);
                  setOpenDropdownId(null);
                }}
                className="action-dropdown-item"
              >
                <MdEdit className="text-base" />
                Edit
              </button>

              <div className="action-dropdown-divider" />

              <button
                onClick={() => {
                  onAskDelete(item);
                  setOpenDropdownId(null);
                }}
                className="action-dropdown-item"
              >
                <MdDelete className="text-base" />
                Delete
              </button>
            </div>
          )}
        </td>
      </tr>

      {/* Render Child Sub-Pavilions recursively */}
      {hasChildren &&
        expanded &&
        item.children.map((childNode) => (
          <TreeRow
            key={childNode._id}
            item={childNode}
            level={level + 1}
            onEdit={onEdit}
            onAskDelete={onAskDelete}
            openDropdownId={openDropdownId}
            setOpenDropdownId={setOpenDropdownId}
            openUpward={openUpward}
            setOpenUpward={setOpenUpward}
            dropdownRef={dropdownRef}
          />
        ))}
    </>
  );
}

export default function PavilionTable({ data = [], onEdit, onDelete }) {
  const [deleteRow, setDeleteRow] = useState(null);
  const [loading, setLoading] = useState(false);

  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [openUpward, setOpenUpward] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleDelete = async () => {
    try {
      setLoading(true);
      await onDelete(deleteRow._id);
      setDeleteRow(null);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="table-scroll-body">
        <table className="custom-table">
          <thead className="custom-table-header">
            <tr>
              <th>Pavilion Name</th>
              <th className="w-16 text-center"></th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 ? (
              <tr>
                <td
                  colSpan="2"
                  className="custom-table-cell py-12 text-center text-gray-500"
                >
                  No pavilions found
                </td>
              </tr>
            ) : (
              data.map((item) => (
                <TreeRow
                  key={item._id}
                  item={item}
                  level={0}
                  onEdit={onEdit}
                  onAskDelete={setDeleteRow}
                  openDropdownId={openDropdownId}
                  setOpenDropdownId={setOpenDropdownId}
                  openUpward={openUpward}
                  setOpenUpward={setOpenUpward}
                  dropdownRef={dropdownRef}
                />
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Confirmation Modal */}
      <ConfirmModal
        open={Boolean(deleteRow)}
        title="Delete Pavilion"
        message={`Are you sure you want to delete pavilion "${deleteRow?.pavilion_name}"? This action cannot be undone.`}
        confirmText="Delete"
        loading={loading}
        onConfirm={handleDelete}
        onCancel={() => setDeleteRow(null)}
      />
    </>
  );
}